/**
 * Amounts are integers in XAF (D-014). Display: « 1 000 000 FCFA » (project rules).
 * Thousands are separated by a no-break space (U+00A0): it never wraps and renders on every
 * Android phone and in WhatsApp, unlike the narrow no-break space produced by Intl (D-045).
 */

export const NBSP = " ";

export function formatXaf(amount: number, options: { suffix?: boolean } = {}): string {
  if (!Number.isSafeInteger(amount)) {
    throw new RangeError(`XAF amounts must be safe integers, got ${amount}`);
  }
  const sign = amount < 0 ? "-" : "";
  const digits = Math.abs(amount).toString().replace(/\B(?=(\d{3})+(?!\d))/g, NBSP);
  return options.suffix === false ? `${sign}${digits}` : `${sign}${digits}${NBSP}FCFA`;
}

/** What people type (« 1 500 000 », « 1.500.000 FCFA ») → integer. */
export function parseXaf(input: string): number {
  const digits = input.replace(/fcfa|xaf/gi, "").replace(/[\s\u00A0\u202F.,]/g, "");
  if (!/^-?\d+$/.test(digits)) throw new Error(`Invalid amount: ${input}`);
  return Number.parseInt(digits, 10);
}
